import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { propArrayShape, propFunc, propNumber, } from '../../../../helpers/custom-prop-types';
const StudyCaseCardNav = (props) => {
    const { active, loadStudyCase, tags } = props;
    return (_jsx("div", Object.assign({ className: 'card_body_section_nav' }, { children: _jsx("ul", { children: tags.map((tag) => (_jsx("li", Object.assign({ className: tag.id === active ? 'is-active' : '' }, { children: _jsx("button", Object.assign({ onClick: loadStudyCase, type: 'button', value: tag.id }, { children: tag.name })) }), tag.id))) }) })));
};
StudyCaseCardNav.propTypes = {
    active: propNumber().isRequired,
    loadStudyCase: propFunc().isRequired,
    tags: propArrayShape().isRequired,
};
export default StudyCaseCardNav;
